import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import classes from './listingsModal.module.css';

import { ReactComponent as CloseIcon } from 'asset/IconsPack/at_x-close.svg';

// `headerRef` is optional: the wrapper is `position: fixed`, so a caller that
// offsets its own content by the header height needs to be able to measure it
// rather than hardcode a value that only holds at some viewport widths.
const Header = ({ title, subTitle, onClose, children, headerRef }) => {
    return (
        <Box className={classes.headerWrapper} ref={headerRef}>
            <Box className={classes.header}>
                <Box>
                    <Typography className={classes.title}>{title}</Typography>
                    {subTitle && <Typography className={classes.subTitle}>{subTitle}</Typography>}
                </Box>
                <Box className={classes.closeIconWrapper}>
                    <CloseIcon className={classes.closeIcon} onClick={onClose} />
                </Box>
            </Box>
            {children}
        </Box>
    );
};

Header.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.node,
    headerRef: PropTypes.object,
};

export default Header;
